module.exports = __webpack_public_path__ + "static/media/carousel-arrow-left.ea49b4ae.svg";